import React from "react";
import GolfTiersDisplay from "./GolfTiersDisplay";

const TiersDisplayHandler = ({league}) => {

    if (league === 'GOLF') {
        return <GolfTiersDisplay />;
    }
    // Add other league conditions here if needed
    return null; // or a default component
}

export default TiersDisplayHandler;
